import { uid } from "quasar";

// Preserve the logical operation across Axios retries. A fresh user action receives a fresh UUID.
export function ensureActivityOperation(config) {
  if ((config.method || "get").toLowerCase() !== "post") return config;
  const url = (config.url || "").split("?")[0];
  if (!/(?:\/invite-contact|\/contacts\/external-import|\/point-of-contact\/import\/\d+)$/.test(url)) return config;
  config.headers = config.headers || {};
  if (!config.headers["Idempotency-Key"]) config.headers["Idempotency-Key"] = uid();
  return config;
}
